import { create } from 'zustand';

/** エディタモーダルの開閉。入口 (背景・構図) と「テキスト」の「レイアウトで編集」の両方から開く */
interface BannerLayoutEditorState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useBannerLayoutEditorStore = create<BannerLayoutEditorState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
